import React, { useContext, useEffect, useState } from 'react';

import UserTypes from 'components/home/user-types/UserTypes';
import HelpBlock from 'components/home/help-block/HelpBlock';
import UserTypeContent from 'components/home/user-type-content/UserTypeContent';
import LayoutContext from 'context/layout';
import FaqService from 'services/faqService';

const HomePage = () => {
    const { setState } = useContext(LayoutContext);
    const [ mainParticipantsData, setMainParticipantsData ] = useState({ sections: [], articles: [] });
    const [ mainOrganizerData, setMainOrganizerData ] = useState({ sections: [], articles: [] });

    useEffect(() => {
		setState({ displaySearch: true, isHome: true });
        getMostAccessedArticles();
        getMainParticipantSections();
        getMainOrganizerSections();
	}, []);

    const getMostAccessedArticles = () => {
        FaqService.getArticlesMostAccessed()
            .then(({ data }) => {
                setMainParticipantsData(old => ({ ...old, articles: data.mostAccessedParticipant }));
                setMainOrganizerData(old => ({ ...old, articles: data.mostAccessedOrganizer }));
            })
    }

    const getMainParticipantSections = () => {
        const params = { size: 9 };
        const payload = { categoryType: 'PARTICIPANT' };
        FaqService.getSections(params, payload)
            .then(({ data }) => {
                setMainParticipantsData(old => ({ ...old, sections: data.content }));
            })
    }

    const getMainOrganizerSections = () => {
        const params = { size: 9 };
        const payload = { categoryType: 'ORGANIZER' };

        FaqService.getSections(params, payload)
            .then(({ data }) => {
                setMainOrganizerData(old => ({ ...old, sections: data.content }));
            })
    }

	return (
		<>
			<UserTypes />

            <UserTypeContent
                title="Comprei ingresso ou participei de um evento"
                sections={mainParticipantsData.sections}
                articles={mainParticipantsData.articles}
            />
            <UserTypeContent
                title="Organizei ou vou organizar um evento"
                sections={mainOrganizerData.sections}
                articles={mainOrganizerData.articles}
            />

            <HelpBlock />
		</>
	);
};

export default HomePage;